module.exports = __webpack_public_path__ + "static/media/nodelogo.f8dab57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/nodelogo.png
// module id = 816
// module chunks = 0